import React, { useEffect } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import loadScript from '@daedalus/core/src/_web/utils/network/loadScript';
const LOADER_SCRIPT_URL = 'https://www.urlaubspiraten.de/hp-app/web/loader.js';
const HpHeader = /*#__PURE__*/styled('div')({
  name: "HpHeader",
  class: "h19e8u6y",
  propsAsIs: false
});
interface Props {
  /** Whether to float the header above the content. Default is `false` */
  isFloating?: boolean;
  /** Whether to fix the header to the top of the page. Default is `true` */
  isFixed?: boolean;
}

/**
 * Displays a custom header for HolidayPirates, including the loader script
 * @returns A React component that displays a custom header for HolidayPirates
 * @remarks
 * - Loads the HolidayPirates loader script as a side effect
 * - Only works in domains that have been whitelisted by HolidayPirates
 */
export const HolidayPiratesHeader = ({
  isFloating = false,
  isFixed = true
}: Props) => {
  useEffect(() => {
    loadScript(LOADER_SCRIPT_URL, false).catch(error => {
      console.error('Failed to load HolidayPirates loader script:', error);
    });
  }, []);
  return <HpHeader id="hp-header" data-partner="vio" data-market="de" className={cx((isFloating || !isFixed) && '__floating', isFixed ? '__fixed' : '__relative')} />;
};

require("./HolidayPiratesHeader.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HolidayPiratesHeader.tsx");